import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M2 1h4c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1H2c-.552 0-1-.448-1-1V2c0-.552.448-1 1-1zm1 2v2h2V3H3zM2 9h4c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1H2c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1zm1 2v2h2v-2H3zM10 1h4c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1V2c0-.552.448-1 1-1zm1 2v2h2V3h-2zM10.5 8.8h-1c-.387 0-.7.313-.7.7v1c0 .387.313.7.7.7h1c.387 0 .7-.313.7-.7v-1c0-.387-.313-.7-.7-.7zM14.5 8.8h-1c-.387 0-.7.313-.7.7v1c0 .387.313.7.7.7h1c.387 0 .7-.313.7-.7v-1c0-.387-.313-.7-.7-.7zM14.5 12.8h-1c-.387 0-.7.313-.7.7v1c0 .387.313.7.7.7h1c.387 0 .7-.313.7-.7v-1c0-.387-.313-.7-.7-.7zM10.5 12.8h-1c-.387 0-.7.313-.7.7v1c0 .387.313.7.7.7h1c.387 0 .7-.313.7-.7v-1c0-.387-.313-.7-.7-.7z"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M12.5 10.8h-1c-.387 0-.7.313-.7.7v1c0 .387.313.7.7.7h1c.387 0 .7-.313.7-.7v-1c0-.387-.313-.7-.7-.7z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M4 2h5c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2zm0 2v5h5V4H4zM4 13h5c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2v-5c0-1.105.895-2 2-2zm0 2v5h5v-5H4zM15 2h5c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2h-5c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2zm0 2v5h5V4h-5z"
        />
        <rect
          width="3"
          height="3"
          x="13"
          y="13"
          className="icon-color"
          rx=".5"
          transform="matrix(-1 0 0 1 29 0)"
        />
        <rect
          width="3"
          height="3"
          x="19"
          y="13"
          className="icon-color"
          rx=".5"
          transform="matrix(-1 0 0 1 41 0)"
        />
        <rect
          width="3"
          height="3"
          x="16"
          y="16"
          className="icon-color"
          rx=".5"
          transform="matrix(-1 0 0 1 35 0)"
        />
        <rect
          width="3"
          height="3"
          x="19"
          y="19"
          className="icon-color"
          rx=".5"
          transform="matrix(-1 0 0 1 41 0)"
        />
        <rect
          width="3"
          height="3"
          x="13"
          y="19"
          className="icon-color"
          rx=".5"
          transform="matrix(-1 0 0 1 29 0)"
        />
      </g>
    </svg>
  ),
};
